module.exports = __webpack_public_path__ + "img/objText.0d826754.svg";